var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Annexures")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Client Annexure List"
    },
    on: {
      "click": _vm.showAnnexure
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Company Short/Display Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.CompanyShortList,
      "name": "companyName",
      "placeholder": "Select Company Name",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selectCompanyName
    },
    model: {
      value: (_vm.selectedcompanyName),
      callback: function($$v) {
        _vm.selectedcompanyName = $$v
      },
      expression: "selectedcompanyName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('companyName')),
      expression: "errors.has('companyName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select company name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contract ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text-o' style='font-size: 12px'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('contractId')
    },
    attrs: {
      "options": _vm.contractIdList,
      "selected-option": _vm.selectedContractId,
      "name": "contractId",
      "placeholder": "Select Contract ID"
    },
    on: {
      "select": _vm.selectContractId
    },
    model: {
      value: (_vm.contractId),
      callback: function($$v) {
        _vm.contractId = $$v
      },
      expression: "contractId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contractId')),
      expression: "errors.has('contractId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select contract id.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Annexure Name ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-certificate' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annexurename),
      expression: "annexurename"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('annexurename')
    },
    attrs: {
      "type": "text",
      "name": "annexurename",
      "id": "annexurename",
      "placeholder": "Enter Annexure Name",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.annexurename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.annexurename = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('annexurename')),
      expression: "errors.has('annexurename')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter annexure name.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Annexure Description ")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annexuresdescription),
      expression: "annexuresdescription"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Description",
      "name": "annexuresdescription",
      "id": "annexuresdescription"
    },
    domProps: {
      "value": (_vm.annexuresdescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.annexuresdescription = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 5px 0px"
    },
    attrs: {
      "for": "uploadAnnexure"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("  Click to Upload Annexure")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), (_vm.AnnexureFilePath != '') ? _c('span', [_vm._v(" \n                  "), (_vm.fileExtension == 'png' || _vm.fileExtension == 'jpg' || _vm.fileExtension == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Download Document"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.AnnexureFilePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fileExtension == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.AnnexureFilePath)
      }
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "files",
    class: {
      'form-control': true,
      'error': _vm.errors.has('uploadAnnexure')
    },
    attrs: {
      "id": "uploadAnnexure",
      "name": "uploadAnnexure",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChangedForAnnexure
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientnote",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format JPG,JPEG,PDF,PNG."), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to 20MB.\n            ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadAnnexure')),
      expression: "errors.has('uploadAnnexure')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please upload file.")])])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4aba8ce","hasScoped":true}!./src/modules/clientmanagement/views/ClientAnnexures/CreateClientAnnexures/CreateClientAnnexures.component.html
// module id = 751
// module chunks = 3